import { Link } from "react-router-dom";
import { LiaLinkedin } from "react-icons/lia";
import { INSIGHTS_LINKS } from "../data/insights";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-brand-bg text-white pt-16 pb-8" style={{}}>
      <div className="container mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <div className="mb-2 text-left">
              <img
                src="/assets/image.png_7846.svg"
                alt="Momentum Realty Group - NYC Commercial Real Estate Solutions"
                className="  w-4/5 sm:w-3/5 md:w-full lg:w-4/5 xl:w-4/5  max-w-full object-contain"
              />
            </div>
            <div className="mb-4">
              <img
                src="/assets/MRG-v2-01-2.svg"
                alt="MRG - Premium Commercial Real Estate Services in New York"
                className=" w-4/5 sm:w-3/5 md:w-full lg:w-4/5 xl:w-4/5  max-w-full object-contain  	"
              />
            </div>
            <p className="text-gray-400 text-sm mb-6">
              Momentum Realty Group — Premier Commercial Real Estate in NYC
            </p>
            <div className="flex space-x-4">
              <a
                href="https://linkedin.com"
                className="hover:text-gray-300 transition-colors"
                aria-label="LinkedIn"
              >
                <LiaLinkedin size={40} />
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-6 tracking-wide text-brand-text">
              NAVIGATION
            </h3>
            <ul className="grid grid-cols-2 lg:grid-cols-1 gap-2">
              <li>
                <Link
                  to="/"
                  className="text-gray-400 hover:text-white transition-colors py-1 text-lg"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/properties"
                  className="text-gray-400 hover:text-white transition-colors py-1 text-lg"
                >
                  Properties
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-gray-400 hover:text-white transition-colors py-1 text-lg"
                >
                  About
                </Link>
              </li>
              <li>
                <Link
                  to="/team"
                  className="text-gray-400 hover:text-white transition-colors py-1 text-lg"
                >
                  Team
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-gray-400 hover:text-white transition-colors py-1 text-lg"
                >
                  Contact
                </Link>
              </li>
              <li>
                <Link
                  to="/careers"
                  className="text-gray-400 hover:text-white transition-colors py-1 text-lg"
                >
                  Careers
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-6 tracking-wide text-brand-text">
              ARTICLES
            </h3>
            <ul className="space-y-2">
              {INSIGHTS_LINKS.map((article) => (
                <li key={article.path}>
                  <Link
                    to={article.path}
                    className="text-gray-400 hover:text-white transition-colors py-1 text-lg"
                  >
                    {article.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-6 tracking-wide text-brand-text">
              CONTACT
            </h3>
            <div className="space-y-4">
              <div className="flex items-start">
                <img
                  src="/assets/location.svg"
                  alt=""
                  className="mr-3 mt-1 flex-shrink-0"
                />
                <p className="text-gray-400">
                  1430 Broadway #308
                  <br />
                  New York, NY 10018
                </p>
              </div>
              <div className="flex items-center group">
                <img
                  src="/assets/phone.svg"
                  alt=""
                  className="mr-3 flex-shrink-0 group-hover:contrast-200"
                />
                <a
                  href="tel:+12123144684"
                  className="text-gray-400 hover:text-white transition-colors text-lg"
                >
                  +1 (212) 314-4684
                </a>
              </div>
              <div className="flex items-center group">
                <img
                  src="/assets/email.svg"
                  alt=""
                  className="mr-3 flex-shrink-0  group-hover:contrast-200"
                />
                <a
                  href="mailto:info@mrgny.com"
                  className="text-gray-400 hover:text-white transition-colors text-lg"
                >
                  info@mrgny.com
                </a>
              </div>
            </div>
          </div>
        </div>

        <div
          className="border-t pt-8 text-gray-200 text-sm"
          style={{ borderTopColor: "#39E390" }}
        >
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0 text-base">
            <p>© {currentYear} Momentum Realty Group. All rights reserved.</p>
            <div className="flex space-x-6">
              <Link
                to="/privacy-policy"
                className="text-gray-400 hover:text-white transition-colors"
              >
                Privacy Policy
              </Link>
              <Link
                to="/terms-and-conditions"
                className="text-gray-400 hover:text-white transition-colors"
              >
                Terms & Conditions
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
